<section class="auth-login">
  <p class="auth-subtitle">{{ "login.extensionAuthSubtitle" | translate }}</p>

  <div class="auth-stack" *ngIf="!invalidRedirect">
    <button class="auth-btn auth-btn-social" [disabled]="redirecting" (click)="loginWithGoogle()">
      <img src="/assets/img/google-logo.svg" alt="Google Logo" class="auth-icon" />
      {{ (redirecting ? "login.redirecting" : "login.google") | translate }}
    </button>

    <button class="auth-btn auth-btn-social" [disabled]="redirecting" (click)="loginWithMicrosoft()">
      <img src="/assets/img/microsoft-logo.svg" alt="Microsoft Logo" class="auth-icon" />
      {{ (redirecting ? "login.redirecting" : "login.microsoft") | translate }}
    </button>
  </div>

  <div class="auth-divider" *ngIf="!invalidRedirect">
    <span>{{ "login.or" | translate }}</span>
  </div>

  <div class="auth-stack" *ngIf="!invalidRedirect">
    <input
      type="email"
      [(ngModel)]="email"
      [placeholder]="'login.emailPlaceholder' | translate"
      class="auth-input"
      autocomplete="username"
      [disabled]="redirecting"
      (keyup.enter)="loginWithPassword()"
    />
    <input
      type="password"
      [(ngModel)]="password"
      [placeholder]="'login.passwordPlaceholder' | translate"
      class="auth-input"
      autocomplete="current-password"
      [disabled]="redirecting"
      (keyup.enter)="loginWithPassword()"
    />
    <button
      class="auth-btn auth-btn-primary"
      type="button"
      (click)="loginWithPassword()"
      [disabled]="!canSubmitPassword"
    >
      {{ (redirecting ? "login.redirecting" : "login.passwordSignIn") | translate }}
    </button>
  </div>

  <p class="auth-feedback auth-feedback-error" *ngIf="errorMessage">{{ errorMessage }}</p>
</section>
